<script setup>
import {computed, onMounted, ref} from "vue";
import PrimaryButton from "@/components/buttons/PrimaryButton.vue";
import NoSubjects from '@/assets/gamification/no_subjects.png';
import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import Loading from '@/components/Loading.vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const route = useRoute()
const router = useRouter()
const store = useStore()

const loading = ref(true)
const search = ref('')

const seminars = computed(()=> store.getters['Seminars/seminars'])

const headers = [
  { title: t('gamification.seminar_name'), align: 'start', key: 'name', width: "70%",},
  { title: t('gamification.admin'), align: 'start', key: 'owner', width: "30%",},
]

function goToSeminarDetail(seminarId) {
  router.push({
    name: 'SeminarDetail',
    params: {seminarId: seminarId, subjectId: Number(route.params.subjectId)}
  })
}

async function fetchSeminars(){
  await store.dispatch('Seminars/fetchSeminarsBySubjectId',{subjectId: Number(route.params.subjectId)})
  loading.value = false
}

onMounted(async ()=>{
  await fetchSeminars()
})

</script>

<template>
  <Loading v-if="loading" />
  <div class="pt-5" v-else>
    <v-text-field class="w-33" v-if="seminars.length > 0" v-model="search" :placeholder="t('gamification.search_seminar')" variant="underlined" />
    <v-data-table
        v-if="seminars.length > 0"
        class="pt-2"
        :headers="headers"
        :items="seminars"
        :no-data-text="t('gamification.no_data')"
        :search="search"
        hover
    >
      <template v-slot:item="{ item }">
        <tr>
          <td><b class="cursor-pointer text-primary" @click="goToSeminarDetail(item.id)">{{item.title}}</b></td>
          <td>
            <!--TODO: missing owner from backend -->
            {{item.owner?.fullName}}
          </td>
        </tr>
      </template>

    </v-data-table>
    <div v-else>
      <div class="w-100 d-flex flex-column justify-center align-center">
        <img
            style="width: 400px"
            :src="NoSubjects"
            alt="noSubjectsImage">
        <div class="text-h5">{{t('gamification.no_seminars')}}</div>
        <div class="text-h6 font-weight-light text-grey-darken-1">{{t('gamification.no_seminars_added')}}</div>
        <PrimaryButton class="mt-5" @click="goToSeminarDetail('new')">
          {{t('gamification.add_seminar')}}
        </PrimaryButton>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>